import './ByList.less';

import React, { FC } from 'react';
interface IByListProps {
  title?: string;
  subTitle?: string | null;
  children?: React.ReactNode;
  verifyAccount?: number;
}

interface IByItemProps {
  children?: React.ReactNode;
  padding?: number | string;
}
const ByList: FC<IByListProps> = (props) => {
  return (
    <div className={'bylist-container'}>
      {props.title && (
        <div className="bylist-container-title">
          <span className="bylist-title">{props.title}</span>
        </div>
      )}
      {props.children}
    </div>
  );
};

const ByItem: FC<IByItemProps> = (props) => {
  return (
    <div className="bylist-item-container">
      <div
        className="bylist-item"
        style={{ padding: props.padding ? props.padding : '' }}
      >
        {props.children}
      </div>
    </div>
  );
};

export { ByItem, ByList };

/**
 *  {/* {props.verifyAccount && false && (
          <>
            <span className="bylist-verify-count">{props.verifyAccount}</span>
            <span className="bylist-verify-text">项安全待验证</span>
          </>
        )}
      */
